import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import _regeneratorRuntime from "@babel/runtime/regenerator";
// 企业微信-企业内部应用-鉴权相关
import { pick } from '../tools';
import { browser } from '../const';
import { loadWxConfig, loadWxServeConfig } from '../service/config';
import Config from './base.config';
import protocol from '../protocol/wx.protocol';
import { EcoType } from '../const/enums';
import wxJsApi from './jsApi/wx.apilist'; // 必填，需要使用的JS接口列表

var jsApiList = wxJsApi.all; // 微信鉴权相关的JS依赖
// const configSdkPath = 'https://res.wx.qq.com/open/js/jweixin-1.2.0.js';

export var WxConfig = /*#__PURE__*/function (_Config) {
  _inheritsLoose(WxConfig, _Config);

  function WxConfig(options) {
    var _this;

    _this = _Config.call(this, options) || this; // 当前环境是否支持 wx config 鉴权

    _this.protocol = _this.wxProtocol;
    _this.configType = EcoType.wx;
    _this.isWxServe = true;
    _this.support = !!browser.wx; // WX SDK是否准备就绪

    _this.wxSdkReady = false; // 是否成功 wx.config 鉴权

    _this.wxConfigOK = false; // 最后一次鉴权成功的时间，timeSpans

    _this.lastWxConfigTime = null;
    return _this;
  }
  /**
   * 当前生态配套的统一协议入口，微信SDK（wx.*** 协议分需要/不需要鉴权）
   */


  var _proto = WxConfig.prototype;

  /**
   * 当前生态配套的统一协议入口，微信SDK（wx.*** 协议分需要/不需要鉴权）
   * 供派生类直接访问微信基类的协议使用
   */
  _proto.wxProtocol =
  /*#__PURE__*/
  function () {
    var _wxProtocol = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(protocolName, data) {
      var isInvokeApi;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              isInvokeApi = wxJsApi.invoke.includes(protocolName); // 微信SDK，需要微信鉴权

              if (!wxJsApi.authority.includes(protocolName)) {
                _context.next = 4;
                break;
              }

              _context.next = 4;
              return this.onWxReady();

            case 4:
              return _context.abrupt("return", protocol(protocolName, data, isInvokeApi));

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function wxProtocol(_x, _x2) {
      return _wxProtocol.apply(this, arguments);
    }

    return wxProtocol;
  }()
  /**
   * 当前类的ready事件，整套鉴权
   * 派生类可覆写该方法，使用onWxReady来确保微信config
   * 在微信生态下，onReady统一用wx.config来实现
   * @returns this.wxConfigOK:config 鉴权是否成功
   */
  ;

  _proto.onReady = function onReady() {
    return this.onWxReady();
  }
  /**
   * 当前类的ready事件，供派生类使用, 使用onWxReady来确保微信config
   * @returns this.wxConfigOK:config 鉴权是否成功
   */
  ;

  _proto.onWxReady =
  /*#__PURE__*/
  function () {
    var _onWxReady = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.loadWxSDK();

            case 2:
              if (!(this.wxSdkReady && !this.wxConfigOK)) {
                _context2.next = 6;
                break;
              }

              _context2.next = 5;
              return this.wxConfig(this.orgId, this.agentId);

            case 5:
              this.wxConfigOK = _context2.sent;

            case 6:
              return _context2.abrupt("return", this.wxConfigOK);

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function onWxReady() {
      return _onWxReady.apply(this, arguments);
    }

    return onWxReady;
  }()
  /**
   * 加载SDK
   * @returns this.wxSdkReady : SDK是否准备就绪
   */
  ;

  _proto.loadWxSDK =
  /*#__PURE__*/
  function () {
    var _loadWxSDK = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (this.wxSdkReady) {
                _context3.next = 7;
                break;
              }

              _context3.t0 = !!window.wx;

              if (_context3.t0) {
                _context3.next = 6;
                break;
              }

              _context3.next = 5;
              return WxConfig.loadSDK();

            case 5:
              _context3.t0 = _context3.sent;

            case 6:
              this.wxSdkReady = _context3.t0;

            case 7:
              return _context3.abrupt("return", this.wxSdkReady);

            case 8:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function loadWxSDK() {
      return _loadWxSDK.apply(this, arguments);
    }

    return loadWxSDK;
  }()
  /**
   * 微信鉴权，wx.config
   * @returns this.wxConfigOK :  config 鉴权是否成功
   */
  ;

  _proto.wxConfig =
  /*#__PURE__*/
  function () {
    var _wxConfig = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(orgId, agentId) {
      var _this2 = this;

      var loadConfigFn, configResult, newConfig, defaultConfig, _defaultConfig$jsApiL, config, myWxConfig;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (browser.wx) {
                _context4.next = 3;
                break;
              }

              this.log('wxConfig: not weixin client');
              return _context4.abrupt("return", false);

            case 3:
              if (!this.wxConfigOK) {
                _context4.next = 5;
                break;
              }

              return _context4.abrupt("return", this.wxConfigOK);

            case 5:
              loadConfigFn = this.isWxServe ? loadWxServeConfig : loadWxConfig;
              _context4.next = 8;
              return loadConfigFn({
                agentId: agentId,
                orgId: orgId
              });

            case 8:
              configResult = _context4.sent;

              if (configResult) {
                _context4.next = 12;
                break;
              }

              console.error('load weixin config error', configResult);
              return _context4.abrupt("return", false);

            case 12:
              /*
                  appId  必填，企业微信的corpID
                  timestamp  必填，生成签名的时间戳
                  nonceStr  必填，生成签名的随机串
                  signature 必填，签名，见 附录-JS-SDK使用权限签名算法
              */
              newConfig = pick(configResult, ['appId', 'timestamp', ['noncestr', 'nonceStr'], 'signature']);
              defaultConfig = {
                beta: true,
                // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
                debug: !!localStorage.isDebug,
                // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                jsApiList: jsApiList // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来

              }; // 如果当前实例由当前类初始化完成（微信服务号/公众号），则需要追加apiList

              if (this.isWxServe) {
                (_defaultConfig$jsApiL = defaultConfig.jsApiList).push.apply(_defaultConfig$jsApiL, this.apiList);
              }

              config = _extends({}, defaultConfig, newConfig);

              myWxConfig = function myWxConfig() {
                return new Promise(function (resolve, reject) {
                  var flag = false;
                  console.info('wx.config', config);
                  window.wx.ready(function (res) {
                    if (flag) return;

                    _this2.log('wx.config success:', res, config); // 记录最后一次鉴权成功的时间点


                    _this2.lastWxConfigTime = new Date().valueOf();
                    resolve(true);
                    flag = true;
                  });
                  window.wx.error(function (err) {
                    if (flag) return;

                    _this2.log('wx.config fail:', err, config);

                    reject(false);
                    flag = true;
                  });
                  window.wx.config(config);
                });
              };

              _context4.next = 19;
              return myWxConfig().catch(function () {
                return false;
              });

            case 19:
              this.wxConfigOK = _context4.sent;
              this.log('wx.config ok:', this.wxConfigOK);
              return _context4.abrupt("return", this.wxConfigOK);

            case 22:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function wxConfig(_x3, _x4) {
      return _wxConfig.apply(this, arguments);
    }

    return wxConfig;
  }();

  return WxConfig;
}(Config);
;
/** WxConfig 对象 单例模式 */

var configInstanse = null;
/**
 * 返回鉴权单例对象
 * @param options: Configure.Options 配置参数，只有在初次鉴权时才有效
 * @returns WxConfig 配置对象
 */

var wx = function wx(data) {
  var options = typeof data === 'string' ? {
    agentId: data
  } : data;
  configInstanse = configInstanse || new WxConfig(options);
  return configInstanse;
};

export default wx;